var modules_a1a2e57d = {"block":"_1ldlm1n","item":"_1iu0xs1"};
import "../../../assets/xfxmeLvu.css";

export { modules_a1a2e57d as default };
//# sourceMappingURL=organization-rating.module.scss.js.map
